var exports = {
  "qr": "EditingMessageInput.module__footer___MlROWk",
  "s6": "EditingMessageInput.module__footerLink___MlROWk",
  "me": "EditingMessageInput.module__separator___MlROWk",
  "EN": "EditingMessageInput.module__editor___MlROWk",
};

module.exports = exports;
